import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const ProfileHeader = ({ fullName, email }) => {
  return (
    <div className='primary__menu__bottom__profile__menu__inner__seperator primary__menu__bottom__profile__menu__inner__info'>
      <h6 className='primary__menu__bottom__profile__menu__inner__info__name'>
        {fullName}
      </h6>
      <div className='primary__menu__bottom__profile__menu__inner__info__email email_field'>
        {email}
      </div>
    </div>
  );
};

ProfileHeader.propTypes = {
  fullName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};

export default ProfileHeader;
